(function() {
    'use strict';

    angular
        .module('TR')
        .directive('salesBanner', salesBanner);

    function salesBanner() {
        return {
            restrict: 'E',
            scope: {
                imageType: '@',
                onPopulate: '&',
                fallbackTagetUrl: '@',
                imgClass: '@',
            },
            link: _linker,
            template: `
<span gtm-namespace="sales-banner">
    <a ng-href="{{::targetUrl}}" ng-if="::imageSrc && targetUrl">
        <img ng-src="{{::imageSrc}}" ng-class="imgClass" />
    </a>
    <img ng-if="::imageSrc && !targetUrl" ng-src="{{::imageSrc}}" ng-class="imgClass" />
</span>`,
        };

        function _linker(scope) {
            let graphic = TRPCONFIG.Domain.SaleBannerUrls[scope.imageType];
            if (graphic) {
                scope.imageSrc = graphic.ImageSrc;
                scope.targetUrl = graphic.TargetUrl || scope.fallbackTagetUrl;
            }

            if (scope.imageSrc) {
                scope.onPopulate();
            }
        }
    }
})();
